import { useState } from "react";
import { ChevronsUpDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandInput, CommandList, CommandItem } from "@/components/ui/command";
import { logisticsCopy, type BookingPlace } from "@/lib/booking-logistics";

export function BookingPlaceSelect({ id, label, places, value, note, onChange, lang, invalid }: { id: string; label: string; places: BookingPlace[]; value: string; note: string; onChange: (id: string, note: string) => void; lang: string; invalid?: boolean }) {
  const [open, setOpen] = useState(false);
  const [custom, setCustom] = useState(false);
  const [search, setSearch] = useState("");
  const normalize = (v: string) => v.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
  const filtered = places.filter(p => normalize(p.title).includes(normalize(search)));
  const c = logisticsCopy(lang);
  const selected = places.find(p => p.id === value);
  return <div className="space-y-1.5">
    <Label htmlFor={id}>{label}</Label>
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild><Button id={id} variant="outline" role="combobox" aria-expanded={open} aria-invalid={invalid} className="h-11 w-full justify-between rounded-xl text-left font-normal"><span className="truncate">{selected ? `${selected.title}${selected.time ? ` · ${selected.time}` : ""}` : custom ? c[9] : c[11]}</span><ChevronsUpDown className="size-4 shrink-0"/></Button></PopoverTrigger>
      <PopoverContent align="start" className="w-[var(--radix-popover-trigger-width)] max-w-[calc(100vw-32px)] p-0">
        <Command shouldFilter={false}><CommandInput placeholder={c[10]} value={search} onValueChange={setSearch}/><CommandList>
          <CommandItem value={c[9]} onSelect={()=>{setCustom(true);onChange("",note);setOpen(false);}}>{c[9]}</CommandItem>
          {filtered.map(p=><CommandItem key={p.id} value={`${p.title} ${p.id}`} onSelect={()=>{setCustom(false);onChange(p.id,"");setOpen(false);setSearch("");}}><span>{p.title}{p.time ? ` · ${p.time}` : ""}</span></CommandItem>)}
        </CommandList></Command>
      </PopoverContent>
    </Popover>
    {(custom || !!note && !value) && <Input aria-label={c[9]} placeholder={c[9]} value={note} maxLength={300} aria-invalid={invalid} onChange={e=>onChange("",e.target.value)}/>}
  </div>;
}